(function (upp) {
    'use strict';

    //PLUGIN FOR MODULES:
    // * ESHOP
    // * PROMOTIONS

    upp.directive('productsCatalogTpl', [
        function () {
            return {
                restrict: 'E',
                templateUrl: require('../templates/products-catalog.html'),
                replace: true
            }
        }]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/plugins/products/directives/products-templates-directive.js